import React, { useState } from "react";
import { IconButton } from "@mui/material";
import AppButton from "../../components/AppButton";
import { FormattedMessage, useIntl } from "react-intl";
import ResponsiveDialog from "../../components/ResponsiveDialog";
import { CreateFilterForm, FilterDimensionForm } from "./CreateFilterForm";
import { FilterType } from "./FilterType";
import { Filter } from "../../services/Alert";
import AddIcon from "@mui/icons-material/Add";
import { useSnackbar } from "notistack";
import { SX_FORM_SUBMIT, SX_FORM_CANCEL } from "../../Configuration/styles";
import { formInputsStyles } from "../../Configuration/styles";
import { ActionTooltip } from "../../components/Tooltips";
import { slugify, getSearchParam, DIALOG_PARAM } from "../../services/utils";

export const AddPerimeterFilter = ({
  filters,
  onSubmit,
  moduleSlug,
}: {
  filters: Filter[];
  onSubmit: (filter: Filter) => void;
  moduleSlug: string;
}) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const inputStyles = formInputsStyles();
  const [open, setOpen] = React.useState(() => {
    const slug = slugify(
      intl.formatMessage({ id: "ADD_NEW_DIMENSION_FILTER" })
    );
    return getSearchParam(DIALOG_PARAM) === slug;
  });
  const [model, setModel] = useState<FilterDimensionForm>({
    values: [],
  });

  const handleSubmit = (model: FilterDimensionForm) => {
    const exist = filters.find((elem) => elem.target === model.target);

    if (exist) {
      enqueueSnackbar(intl.formatMessage({ id: "FILTER_ALREADY_EXISTS" }), {
        variant: "error",
      });
    } else {
      const newFilter = {
        target: model.target || null,
        type: model.type || FilterType.MULTIPLE,
        options: {
          values: model.values,
        },
      } as Filter;

      onSubmit(newFilter);
      setOpen(false);
      setModel({
        values: [],
      });
    }
  };

  return (
    <>
      <ActionTooltip title={"ADD_NEW_DIMENSION_FILTER_PERIMETER"}>
        <IconButton
          sx={{ color: "text.accentInverted" }}
          onClick={() => setOpen(true)}
          size="small"
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </ActionTooltip>

      <ResponsiveDialog
        classes={inputStyles.classes.paper}
        onClose={() => setOpen(false)}
        open={open}
        maxWidth="sm"
        fullWidth
        title={intl.formatMessage({ id: "ADD_NEW_DIMENSION_FILTER" })}
        actions={
          <>
            <AppButton
              intent="tonal"
              onClick={() => setOpen(false)}
              sx={SX_FORM_CANCEL}
            >
              <FormattedMessage id="CANCEL" />
            </AppButton>
            <AppButton
              form="create-filter-form"
              type="submit"
              sx={SX_FORM_SUBMIT}
            >
              <span>
                <FormattedMessage id="SUBMIT" />
              </span>
            </AppButton>
          </>
        }
      >
        <CreateFilterForm
          model={model}
          onSubmit={handleSubmit}
          moduleSlug={moduleSlug}
        />
      </ResponsiveDialog>
    </>
  );
};
